import http from "../../http";

export default {
  list: params => {
    return http.get("opservice/tenant/security/list/role", params);
  },
  gettree: () => {
    return http.get("/opservice/tenant/security/list/menu");
  },
  save: param => {
    return http.post("/opservice/tenant/security/add/role/withuser", param);
  },
  saverole: param => {
    return http.post("/opservice/tenant/security/add/role", param);
  },
  settree: param => {
    return http.get(
      "/opservice/tenant/security/get/relate/role_menu?roleid=" + param
    );
  },
  remove: param => {
    return http.get("/opservice/security/delete/role?id=" + param);
  },
  removeId: param => {
    return http.get("/opservice/tenant/security/delete/admin/user", param);
  },
  userlist: param => {
    return http.get("/opservice/tenant/security/get/role/user", param);
  },
  dialoglist: data => {
    return http.post("opservice/tenant/security/add/admin/userlist", data);
  }
};
